import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { COLORS } from '../styles/colors';
import Modal from '@material-ui/core/Modal';
import ModalHeading from './ModalHeading';
import { EditPost } from '../containers/Community';
export default class EditPostButton extends Component {

	state = {
		open: false
	};

	render() {
		const { item, topic, isMobile } = this.props;
		const { open } = this.state;
		let isFormFields = true;
		let isMedia = true;
		let isMixedAsset = true;
		if (topic !== null &&  topic.topicType === 'PHOTO') {
			isMedia = true;
			isFormFields = false;
			isMixedAsset = false;
		}
		if (topic !== null &&  (topic.topicType === 'DEFAULT' || topic.topicType === 'CHANNEL')) {
			isMedia = true;
			isFormFields = true;
			isMixedAsset = true;
		}
		return (
			<div>
	    	<Modal
	        className="modal show"
	        open={open}
	        onClose={() => this.setState({open:false})}>
	        <div className="modalBody modal-content" style={{
				     width: isMobile ? '90%' : 1050, maxHeight: '90%', overflow: 'auto'}}>
						<ModalHeading
							text={(
								<div>
									<FontAwesomeIcon icon="edit"
										style={{marginRight: 5, color: COLORS.orange}}/>
									<span>Edit Post</span>
								</div>

							)}
							closeModal={() => this.setState({...this.state, open: false})}/>
						<div className="modalContent">
							<EditPost isMobile = {isMobile}  item={item} isMixedAsset={isMixedAsset}  isMedia={isMedia} isFormFields={isFormFields} editId={item._id} onClose={() => this.setState({ open: false })}  />
						</div>
	        </div>
	      </Modal>
		    <span
          className="link"
		  onClick={() => this.setState({open:true})}
          style={{float:'right', color: COLORS.orange, marginLeft: isMobile && 10}}>
          <FontAwesomeIcon size={isMobile && "2x" } icon="edit" title={'Edit'}
            style={{marginRight: 5, color: COLORS.orange}}/>Edit
        </span>
			</div>
    );
	}
}



// WEBPACK FOOTER //
// ./src/components/EditPostButton.js